import { takeLatest, call, put } from 'redux-saga/effects'

import I18n from 'i18n'
import editRequestCourse, {
  EditRequestCourseParams,
  ResponseEditRequestCourse,
} from 'api/requestCourses/EditRequestCourse'
import admin, { ResponseRequestCourses } from 'api/requestCourses/ListAdmin'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'
import { getAccess } from 'contexts/AccessContext'
import {
  EDIT_REQUEST_OUTSIDE_COURSE,
  Actions,
} from '../../actions/requestOutsideCourses.action'
import { ActionWithPayload } from '../../../helpers/redux-actions.helper'

const pattern = EDIT_REQUEST_OUTSIDE_COURSE

export type EditRequestCourseAction = ActionWithPayload<
  typeof pattern,
  {
    params: EditRequestCourseParams
    onSuccess?(): void
    onError?(err: any): void
  }
>

function* editRequestCourseEffectSaga(action: EditRequestCourseAction) {
  const { params, onSuccess, onError } = action.payload
  try {
    // eslint-disable-next-line
    const res: ResponseEditRequestCourse = yield call(editRequestCourse, params)

    try {
      if (getAccess().can('manageCourseRequests')) {
        const data: ResponseRequestCourses = yield call(admin)
        yield put(Actions.setListAdminSuccess(data))
      }
    } catch (error) {
      console.error(error)
    }

    SuccessToast(I18n.t('administration.toastMessages.editSuccess'))
    if (onSuccess) onSuccess()
  } catch (error) {
    console.error('error: ', error)
    if (onError) onError(error)
    ErrorToast(I18n.t('administration.toastMessages.editError'))
    yield put(Actions.setLoading(false))
  }
}

export function* editRequestCourseWatcherSaga() {
  yield takeLatest(pattern, editRequestCourseEffectSaga)
}
